var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 68,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    fill: "#FFC107",
    rx: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M31 26v-1.5m-3.94 3.06L26 26.5m1.06 9L26 36.56m9-9 1.06-1.06m-10.56 5H24m6.5-.5 4.111 12.778 2.889-2.89 3.611 3.612L44 41.611 40.389 38l2.889-2.889z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClick);
export default __webpack_public_path__ + "static/media/click.d722e0dab4b41a5ae648a979e8547ca9.svg";
export { ForwardRef as ReactComponent };